import type { UserRow } from './UsersTable'
import type { UserPermissions } from '@/api/permissions'

export interface AccessSummary {
  funcao: string
  perfilGlobal: string
  escopoTenants: string
  orgContexto: string
}

/**
 * Monta o "Resumo de acesso" (C7) a partir de dados JÁ carregados — sem fetch
 * dedicado. `perms` vem da query compartilhada ['user-permissions', id]
 * (pode estar `undefined` enquanto carrega → degrada para defaults neutros).
 *
 * Função usa `user.roles` (papéis RBAC — o mesmo que a aba "Funções" mostra).
 * O papel Membro/Gestor é POR ORG e não está disponível no nível do drawer.
 */
export function buildAccessSummary(user: UserRow, perms?: UserPermissions): AccessSummary {
  const roles = user.roles ?? []
  const nTenants = (user.tenants ?? []).length
  return {
    funcao: roles.length > 0 ? roles.join(', ') : '—',
    perfilGlobal: perms?.applied_template_name ?? 'Sem perfil',
    escopoTenants: nTenants === 0 ? 'Sem tenants' : `${nTenants} tenant${nTenants > 1 ? 's' : ''}`,
    orgContexto: user.organization_name ?? '—',
  }
}
